<template>
    <div>
        <div class="option-carousel">
            <h3 class="option-name">{{title}}</h3>
            <carousel v-if="options.length" class="carousel" :perPageCustom="[[300, 3], [768, 3], [1024, 3], [1280, 4], [1661, 5]]"
                      :paginationEnabled="false"
                      :navigationEnabled="true">
                <slide v-for="(option, index) in options" :key="option.id + 'optid'">
                    <div class="option__holder">
                        <div class="option"
                             :class="{active: optionOffset === index}"
                             @click="addOption(index, option)">
                            <lazy-image :image="option.file" :circle="true"/>
                        </div>
                        <span class="option__name">{{option.name | cleanName }}</span>
                    </div>
                </slide>
            </carousel>
        </div>
        <Lightbox @closeLightbox="closeLightBox"
                  :single="true"
                  :single-src="imageSource"
                  :toggle="toggleLightbox" />
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue-carousel';
    import Lightbox from "../Shared/Lightbox";
    import LazyImage from "../Shared/LazyImage";

    export default {
        name: "OptionCarousel",
        props: ['name', 'options', 'title'],
        data() {
            return {
                selectedOptions: {},
                optionOffset: -1,
                toggleLightbox: false,
                imageSource: '',
            }
        },
        methods: {
            addOption(index, option) {
                this.optionOffset = index;
                this.$emit('sendOption', this.options[index].category_id, this.options[index].id, this.options[index].file.permalink, this.options[index].name);
                this.imageSource = option.file.permalink;
                this.toggleLightbox = true;
            },
            closeLightBox(value) {
                this.toggleLightbox = value;
            }
        },
        components: {
            Lightbox,
            Carousel,
            Slide,
            LazyImage
        },
        filters: {
            cleanName(val) {
                return val.split('/').pop().trim();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .option-carousel {
        max-width: 500px;
        flex-grow: 1;
    }

    .option-name {
        margin-top: 40px;
        font-size: 1rem;
        font-family: Poppins, Arial, sans-serif;
        color: #2b2b2b;
        margin-bottom: 20px;
    }

    .option {
        width: 72px;
        height: 72px;
        margin: 0 auto;
        border-radius: 50%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        border: 3px solid #ccc;
        opacity: 1;

        &__name {
            display: inline-block;
            margin-top: 5px;
            width: 100%;
            font-size: 0.75rem;
            text-align: center;
            font-family: 'Poppins', Arial, sans-serif;
        }

        &__holder {
            padding: 0 5px;
        }

        &:hover {
            cursor: pointer;
            opacity: 1;
        }

        &.active {
            border: 3px solid #1d1d1d;
        }
    }

    .carousel {
        margin-left: 17px;
    }

    @media only screen and (max-width: 767px) {
        .option-carousel {
            max-width: 280px;
        }
        .carousel {
            margin: 0 5px;
        }
    }
</style>